<h2 mat-dialog-title>{{ 'Select Custom Date Range' | translate }}</h2>
<mat-dialog-content>
    <mat-form-field appearance="outline" class="date-range-field">
        <mat-label>{{ 'Date range' | translate }}</mat-label>
        <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [placeholder]="'Start date' | translate"
                [(ngModel)]="startDate">
            <input matEndDate [placeholder]="'End date' | translate"
                [(ngModel)]="endDate">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button mat-raised-button color="primary" class="apply-btn" [disabled]="!isValid()" (click)="apply()">
        {{ 'Apply' | translate }}
    </button>
</mat-dialog-actions>
